import { Application, OnboardingCompanyProfile } from '__generated__/GQL';

import { ApplicationType } from '../types';

/**
 * Given a Company entity, returns the type of application it's tied to.
 */
const getCompanyApplicationType = ({
  company,
}: {
  company: Pick<
    Application,
    'isCapitalDeposit' | 'isShineStart' | 'isCompanyCreationSASU'
  > & {
    profile: Pick<
      OnboardingCompanyProfile,
      'legalRegistrationNumber' | 'legalName'
    >;
  };
}): ApplicationType | null => {
  if (company.isCompanyCreationSASU) {
    return ApplicationType.SasuCreation;
  }

  if (company.isCapitalDeposit) {
    return ApplicationType.CapitalDeposit;
  }

  if (company.isShineStart) {
    return ApplicationType.ShineStart;
  }

  /**
   * Since we have a finite number of application types, we can safely return Standard here.
   * Previously, we checked if there is a legal registration number or legal name to determine
   * if it's a standard application, but with the new start application flow, we can't rely on
   * these fields to determine the application type, since they are not yet filled when the
   * application is created.
   */

  return ApplicationType.Standard;
};

export default getCompanyApplicationType;
